module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/components/RulesPoints/images/header-divider.71b3523a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/components/RulesPoints/images/header-divider.png
// module id = 2816
// module chunks = 11